(() => {
  if (window.__boefjesGiftWrapLoaded) return;
  window.__boefjesGiftWrapLoaded = true;

  const GIFT_VARIANT_ID = 57355989156105;
  const ROOT = window.Shopify?.routes?.root || '/';

  const messageTimers = new WeakMap();
  let syncInProgress = false;

  async function readResponse(response) {
    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      throw new Error(
        data.description ||
        data.message ||
        'Er ging iets mis met de winkelwagen.'
      );
    }

    return data;
  }

  async function getCart() {
    const response = await fetch(`${ROOT}cart.js`, {
      headers: {
        Accept: 'application/json'
      }
    });

    return readResponse(response);
  }

  async function postCart(endpoint, body) {
    const response = await fetch(`${ROOT}${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    });

    return readResponse(response);
  }

  async function updateLineProperties(line, changes) {
    const cart = await getCart();
    const item = cart.items[line - 1];

    if (!item || Number(item.variant_id) === GIFT_VARIANT_ID) {
      throw new Error('Het artikel kon niet worden gevonden.');
    }

    /*
      Belangrijk:
      Shopify vervangt bij cart/change.js alle properties.
      Daarom behouden we eventuele bestaande properties,
      bijvoorbeeld personalisatie of een naam.
    */
    const properties = {
      ...(item.properties || {})
    };

    Object.entries(changes).forEach(([key, value]) => {
      properties[key] = value;
    });

    return postCart('cart/change.js', {
      line,
      properties
    });
  }

  function desiredGiftQuantity(cart) {
    return cart.items.reduce((total, item) => {
      if (Number(item.variant_id) === GIFT_VARIANT_ID) {
        return total;
      }

      if (item.properties?._Cadeauverpakking === 'Ja') {
        return total + item.quantity;
      }

      return total;
    }, 0);
  }

  async function syncGiftProduct(cart) {
    if (syncInProgress) return cart;

    const wantedQuantity = desiredGiftQuantity(cart);

    const giftLines = cart.items.filter(
      item => Number(item.variant_id) === GIFT_VARIANT_ID
    );

    const currentQuantity = giftLines.reduce(
      (total, item) => total + item.quantity,
      0
    );

    if (
      currentQuantity === wantedQuantity &&
      giftLines.length <= 1
    ) {
      return cart;
    }

    syncInProgress = true;

    try {
      if (wantedQuantity === 0) {
        for (const item of giftLines) {
          await postCart('cart/change.js', {
            id: item.key,
            quantity: 0
          });
        }
      } else if (giftLines.length === 0) {
        await postCart('cart/add.js', {
          items: [
            {
              id: GIFT_VARIANT_ID,
              quantity: wantedQuantity
            }
          ]
        });
      } else {
        const [mainGiftLine, ...extraGiftLines] = giftLines;

        if (mainGiftLine.quantity !== wantedQuantity) {
          await postCart('cart/change.js', {
            id: mainGiftLine.key,
            quantity: wantedQuantity
          });
        }

        for (const item of extraGiftLines) {
          await postCart('cart/change.js', {
            id: item.key,
            quantity: 0
          });
        }
      }

      return getCart();
    } finally {
      syncInProgress = false;
    }
  }

  function refreshCart() {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true
      })
    );
  }

  function setStatus(container, text) {
    const status = container.querySelector('[data-gift-status]');

    if (status) {
      status.textContent = text;
    }
  }

  document.addEventListener('change', async event => {
    const checkbox = event.target.closest('[data-gift-checkbox]');

    if (!checkbox) return;

    const container = checkbox.closest('[data-gift-wrap]');
    const messageContainer = container.querySelector(
      '[data-gift-message-container]'
    );
    const textarea = container.querySelector('[data-gift-message]');
    const counter = container.querySelector('[data-gift-count]');

    const line = Number(container.dataset.line);
    const checked = checkbox.checked;

    messageContainer.hidden = !checked;
    checkbox.disabled = true;

    if (!checked) {
      textarea.value = '';
      counter.textContent = '0';
    }

    setStatus(container, 'Bezig met opslaan…');

    try {
      let cart = await updateLineProperties(line, {
        '_Cadeauverpakking': checked ? 'Ja' : '',
        ...(checked
          ? {}
          : { '_Persoonlijke boodschap': '' })
      });

      cart = await syncGiftProduct(cart);

      refreshCart();
    } catch (error) {
      console.error(error);

      checkbox.checked = !checked;
      messageContainer.hidden = checked;

      setStatus(
        container,
        'Opslaan is niet gelukt. Probeer het opnieuw.'
      );
    } finally {
      checkbox.disabled = false;
    }
  });

  async function saveMessage(textarea, refreshAfter = false) {
    if (!document.documentElement.contains(textarea)) return;

    const container = textarea.closest('[data-gift-wrap]');
    const line = Number(container.dataset.line);

    setStatus(container, 'Wordt opgeslagen…');

    try {
      await updateLineProperties(line, {
        '_Persoonlijke boodschap': textarea.value.slice(0, 120)
      });

      setStatus(container, 'Opgeslagen');

      if (refreshAfter) {
        refreshCart();
      } else {
        window.setTimeout(() => {
          if (document.documentElement.contains(container)) {
            setStatus(container, '');
          }
        }, 1200);
      }
    } catch (error) {
      console.error(error);

      setStatus(
        container,
        'Opslaan is niet gelukt. Probeer het opnieuw.'
      );
    }
  }

  document.addEventListener('input', event => {
    const textarea = event.target.closest('[data-gift-message]');

    if (!textarea) return;

    const container = textarea.closest('[data-gift-wrap]');
    const counter = container.querySelector('[data-gift-count]');

    counter.textContent = textarea.value.length;

    const oldTimer = messageTimers.get(textarea);

    if (oldTimer) {
      window.clearTimeout(oldTimer);
    }

    setStatus(container, 'Wordt opgeslagen…');

    const timer = window.setTimeout(() => {
      saveMessage(textarea, false);
    }, 350);

    messageTimers.set(textarea, timer);
  });

  document.addEventListener('change', event => {
    const textarea = event.target.closest('[data-gift-message]');

    if (!textarea) return;

    const oldTimer = messageTimers.get(textarea);

    if (oldTimer) {
      window.clearTimeout(oldTimer);
    }

    saveMessage(textarea, true);
  });

  /*
    Wanneer de klant de hoeveelheid van een ingepakt artikel
    wijzigt of het artikel verwijdert, passen we automatisch
    het aantal cadeauverpakkingen aan.
  */
  document.addEventListener('cart:change', async event => {
    if (syncInProgress || !event.detail?.cart) return;

    try {
      const cart = event.detail.cart;
      const wantedQuantity = desiredGiftQuantity(cart);

      const giftLines = cart.items.filter(
        item => Number(item.variant_id) === GIFT_VARIANT_ID
      );

      const currentQuantity = giftLines.reduce(
        (total, item) => total + item.quantity,
        0
      );

      if (
        wantedQuantity !== currentQuantity ||
        giftLines.length > 1
      ) {
        await syncGiftProduct(cart);
        refreshCart();
      }
    } catch (error) {
      console.error('Cadeauverpakking synchroniseren mislukt:', error);
    }
  });
})();